module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "quartz-core": "static-1.6378"
    },
    "depPathPrefixes": {
      "quartz-core": "/quartz-core/static-1.6378"
    },
    "bundlingPackage": "documents-public-ui",
    "bundlingPackageVersion": "static-1.34757",
    "project": "quartz-core",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};